<template>
  <div class="">
    <div class="panal mt-20">
      <div class="panal-header">Destinations</div>
      <div class="panal-body">
  
<div class="row">
        
            <div class="col-12 col-md-6 mb-1">
              
    <b-form-select v-model="selected" :options="routes" value-field="Serial" text-field="RouteName" v-b-tooltip.hover title="Destinations"  class="">
     
    </b-form-select>
</div>
       <!-- <div class="col-12 col-md-6 mb-1">
    <b-form-select v-model="selected" :options="routes"  class="form-control su-border"></b-form-select>
</div> -->
 <!-- <div class="col-12 col-md-4 mb-1">
   <h5>text  Daily --- weekly </h5>
</div> -->
<!-- <div class="mt-3 col-12">Selected: <strong> {{ selected }} </strong></div> -->

<div class="col-12 text-center tabs">
  <!-- <b-button variant="success" size="sm" class="mt-2" @click="selectedRoute">Booking</b-button> -->
  <a class=" btn btn-success btn-sm" id="v-pills-History-tab" data-toggle="pill" href="#v-pills-History" role="tab" aria-controls="v-pills-History" aria-selected="false" @click="selectedRoute">Packages</a>


  
  <!-- <a class=" btn btn-success btn-sm" v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]" @click="selectedRoute">Packages</a> -->
  </div>

<div class="mt-3 col-12"><h1 class="text-center"> Top Route</h1></div>

<div class="col-12 col-md-3 mb-1"><img src="../../assets/1.png" class="w-100"/></div>
<div class="col-12 col-md-3 mb-1"><img src="../../assets/2.png" class="w-100"/></div>
<div class="col-12 col-md-3 mb-1"><img src="../../assets/3.png" class="w-100"/></div>
<div class="col-12 col-md-3 mb-1"><img src="../../assets/4.png" class="w-100"/></div>


</div>

      </div>
    </div>
  </div>
</template>

<script>
window.onhashchange=hashTriggerTab;
    window.onload=hashTriggerTab;
    
    function hashTriggerTab(){
        var current_hash=window.location.hash;
        if(current_hash.substring(0,1)=='#')current_hash=current_hash.substring(1);
        if(current_hash!=''){
            var trigger=document.querySelector('.nav-tabs a[href="#'+current_hash+'"]');
            if(trigger){trigger.click(); }
        }
    }

import TransportationService from '../../services/Transportation/Transportation.service'

export default {
  name: "Destinations",
  data() {
    return {
      selected: null,
        routes:[]
    };
  },

  mounted(){
 
    TransportationService.GetAllRoutes().then(response=>{
this.routes = response.data

    })

  },
  methods:{
    selectedRoute(){
     
  if(this.selected == null) return false
      this.$emit('clicked', this.selected)
      // document.querySelector('a#v-pills-Current-tab.nav-link').classList.remove('active')
      // document.querySelector('a#v-pills-History-tab.nav-link').classList.add('active')
    }

  }
}
</script>

<style scoped>
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #ff8600;
}
table tr th {
  background-color: #4caf5000 !important;
  color: #333;
  font-weight: bold;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  border: 1px solid #d4d4d4;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}

.divider {
  *width: 100%;
  height: 1px;
  margin: 9px 1px;
  *margin: -5px 0 5px;
  overflow: hidden;
  /* background-color: #e5e5e5; */
  border-bottom: 1px dotted #e5e5e5;
}
.su-border {
  border-color: #3d8fe3 !important;
  background: #f1f9ff !important;
}
.panal-body {
  padding: 20px;
  color: #333;
}
.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}
.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}
.app-All {
  width: 80%;
  float: left;
}
.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;
}
.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-light th {
  font-size: 14px !important;
}
.table .thead-light th {
  font-size: 14px !important;
  background-color: #eaeaea !important;
}

.panal2 {
  background: #eee;
  border-radius: 10px;
  color: #333;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header2 {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body2 {
  padding: 20px;
  color: #333;
}
.mt-10 {
  margin-top: 10px;
}

.btn {
  margin-left: 5px;
}
</style>